import { render, staticRenderFns } from "./signup_statistics.vue?vue&type=template&id=ed849282&scoped=true&"
import script from "./signup_statistics.vue?vue&type=script&lang=js&"
export * from "./signup_statistics.vue?vue&type=script&lang=js&"
import style0 from "./signup_statistics.vue?vue&type=style&index=0&id=ed849282&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed849282",
  null
  
)

export default component.exports